import React from 'react';
//import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import useStyle from './raidChallengeBlock.style';
import gift from 'assets/seasons/card.png';

export const RaidChallengeBlockView = ({ raid }) => {
  const classes = useStyle();
  return (
    <ContainerFullWidth>
      <div className={classes.root}>
        <img className={classes.giftImage} src={gift} alt="cadeau doré" />
        <div className={classes.content}>
          <div className={classes.text}>
            {/* <p>{raid.tagLine}</p> */}
            <p>
              Vous pouvez continuer à prendre des paiements en CB jusqu'au 16
              novembre minuit ! 💳 ⏰
              <br />
              Incitez vos clients à payer rapidement 🙌 🔥
            </p>
          </div>
        </div>
      </div>
    </ContainerFullWidth>
  );
};

export default RaidChallengeBlockView;
